import { render, staticRenderFns } from "./faq-page.vue?vue&type=template&id=1cc7b324&scoped=true"
import script from "./faq-page.vue?vue&type=script&lang=js"
export * from "./faq-page.vue?vue&type=script&lang=js"
import style0 from "./faq-page.vue?vue&type=style&index=0&id=1cc7b324&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cc7b324",
  null
  
)

export default component.exports